import React from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import { tournamentList } from '../../../redux/actions/app/tournamentList';

const getTournamentStatus = (status) => {
  switch (status) {
    case 'REGISTRATION':
      return 'Регистрация';
    case 'REGISTRATION_FINISH':
      return 'Регистрация завершена';
    case 'GRID_RUNNING':
      return 'Сетка идет';
    case 'GRID_FINISH':
      return 'Сетка завершена';
    default:
      return '-';
  }
};

const AdminTournamentList = () => {
  const columns = [
    {
      label: 'Лого',
      onTransform: (val) => (
        <Box component={'img'} src={val?.logo} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '6px', margin: '0 auto' }}></Box>
      ),
    },
    {
      label: 'Название',
      onTransform: (val) => <Box sx={{ textAlign: 'left', maxWidth: '260px', width: '260px', whiteSpace: 'normal' }}>{val?.name}</Box>,
    },
    {
      label: 'Дата создания',
      onTransform: (val) => (val?.event?.createdAt ? dayjs(val?.event?.createdAt).format('DD.MM.YYYY HH:mm') : '-'),
    },
    {
      label: 'Статус',
      onTransform: (val) => getTournamentStatus(val?.status),
    },
  ];

  const deleteProps = { successText: 'Турнир удален', confirmTitle: `Вы уверены что хотите удалить турнир`, status: 'DELETED' };

  return (
    <div>
      <AdminTableList
        isAction
        isDeleteOnly
        title={'Турниры'}
        sliceName={'app'}
        actionName={'tournamentList'}
        fetch={tournamentList}
        columns={columns}
        textEmpty={'Турниров нет'}
        deleteProps={deleteProps}
        type={'TOURNAMENT'}
      />
    </div>
  );
};

export default AdminTournamentList;
